<div class="row">
    <div class="col col-12">
        <app-header />
    </div>
</div>

<div tuiCardLarge tuiSurface="elevated">
    <div class="row">
        <div class="col col-12">
            <div class="row">
                <div class="col col-12">
                    <div tuiHeader class="header-flex">
                        <h1>Messages de maintenance</h1>
                        <div>
                            @if (messageMaintenanceList0() == undefined || messageMaintenanceList0()?.length == 0) {
                            <button tuiButton (click)="openDialog()">
                                Activer le mode maintenance
                            </button>
                            } @else {
                            <button tuiButton appearance="accent" (click)="destroyAll()">
                                Désactiver le mode maintenance
                            </button>
                            <button tuiButton (click)="openDialog()">
                                Ajouter un message supplémentaire
                            </button>

                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-12">
                    <div class="row">
                        <div class="col col-12">
                            <app-message-maintenance-list [messageMaintenanceList]="messageMaintenanceList0()"
                                [refreshList]="refreshList" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>